import React, { ChangeEvent, ReactElement } from 'react'

import { Input, SectionSubtitle, Textarea } from '../../../../..'
import { useUser } from '../../../../../../context'
import { ItemContainer, LogSectionContainer } from '../styles'

interface ChildrenProps {
  type: 'input' | 'text'
  label: string
  placeholder: string
  id: string
  defaultValue:
    | string
    | {
        title: string
        url: string
      }
    | undefined
}

interface LogsSectionProps {
  sectionNumber: string
  sectionTitle: string
  handleUpdate?: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void
  children?: ReactElement
  childrens?: ChildrenProps[]
}

const LogsSection: React.FC<LogsSectionProps> = ({
  sectionNumber,
  sectionTitle,
  children,
  childrens,
  handleUpdate,
}) => {
  const { onEditionMode } = useUser()

  const renderInputElement = (item: ChildrenProps) => {
    const commonProps = {
      name: item.id,
      id: item.id,
      onChange: handleUpdate,
      placeholder: item.placeholder,
      readOnly: !onEditionMode,
      value: item.defaultValue as string,
      'aria-label': item.label,
    }

    return item.type === 'input' ? (
      <Input {...commonProps} />
    ) : (
      <Textarea {...commonProps} />
    )
  }

  return (
    <LogSectionContainer>
      <SectionSubtitle fontSize={14} fontWeight={500} classSub="section-title">
        <>
          <span>{sectionNumber}</span>
          {sectionTitle}
        </>
      </SectionSubtitle>

      {childrens?.map((item) => (
        <ItemContainer key={item.id}>
          <label htmlFor={item.id}>{item.label}</label>
          {renderInputElement(item)}
        </ItemContainer>
      ))}

      {children}
    </LogSectionContainer>
  )
}

export default LogsSection
